/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
//import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import bgImage from "assets/images/snt-bg.jpeg";
import logoImage from "assets/images/SNT/snt-logo.png";
import { useAuth } from "auth/authProvider";
import { LoadingDialog } from "ui-components/Alert";

function Basic(props) {
  const [rememberMe, setRememberMe] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => {
    setErrorMessage("");
  };
  const navigate = useNavigate();
  const [loading,setLoading] = useState(false)

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const { login, logout } = useAuth();

  useEffect(() => {
    const { triggerLogout } = props;
    if (triggerLogout) {
      logout();
    }
  }, []);

  useEffect(() => {
    if (errorMessage) {
      openErrorSB();
    } else {
      setErrorSB(false);
    }
  }, [errorMessage]);

  const handleLogin = async () => {
    try {
      setLoading(true)
      const data = await login(userName, password);
      if (data) {
        if (data.statusCode === 200) {
          setLoading(false)
          navigate("/");
        } else {
          setLoading(false)
          setErrorMessage(data.message);
        }
      }
    } catch (err) {
      setLoading(false)
      setErrorMessage(err.message);
    }
  };

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Sign In Failed"
      content={errorMessage}
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      dateTime="Now"
      bgWhite
    />
  );

  return (
    <BasicLayout image={bgImage}>
      {loading && <LoadingDialog/>}
      {renderErrorSB}
      <Card>
        {/* <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox> */}
        <MDBox textAlign="center" pt={1}>
          <MDBox component="img" src={logoImage} alt="Logo" width="60%" />
        </MDBox>
        <MDBox pt={0} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="UserName"
                onChange={(e) => setUserName(e.target.value)}
                fullWidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={(e) => {
                  if (e.code === "Enter" && password.trim().length > 0) {
                    handleLogin()
                  }
                }}
                fullWidth
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={handleLogin}>
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
